import api from '../../services/api';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const getPaymentDetails = createAsyncThunk(
  'getPaymentsDetails/fetchAll',
  async (id) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/students/payments/get/${id}`,
        method: 'GET',
      });
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  },
);
export const searchForStudent = createAsyncThunk(
  'searchForStudent/fetchAll',
  async (searchTerm) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/students/searchStudent?search=${searchTerm}`,
        method: 'GET',
      });
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  },
);
export const deleteTransactionById = createAsyncThunk(
  'deleteTransactionById/delete',
  async (id) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/students/payments/${id}`,
        method: 'DELETE',
      });
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  },
);
export const transactionIdCheck = createAsyncThunk(
  'getIdCheck/fetch',
  async (id) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/students/payments/idCheck/${id}`,
        method: 'GET',
      });
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  },
);
export const postPaymentDetails = createAsyncThunk(
  'postPaymentsDetails/post',
  async (paymentData) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/students/payments/`,
        method: 'POST',
        data: paymentData,
        headers: { smsService: localStorage.getItem('smsService') },
      });
      return response?.status;
    } catch (error) {
      console.log(error);
    }
  },
);
const PaymentSlice = createSlice({
  name: 'payments',
  initialState: {
    paymentDetails: [],
    feeStrucute: [],
    status: '',
    error: '',
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPaymentDetails.pending, (state) => {
        state.status = 'loading';
        state.paymentDetails = [];
      })
      .addCase(getPaymentDetails.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.paymentDetails = action.payload;
      })
      .addCase(getPaymentDetails.rejected, (state, action) => {
        state.status = 'error';
        state.error = action.error.message;
      });
  },
});
export default PaymentSlice.reducer;
